/**
 * Presentation metadata (icons, tones, i18n keys) for lead contact logging.
 * Shared by LeadContactSheet, the Contacts section and the timeline card.
 * @module config/leadContactMeta
 */
import {FALLBACK_VOCABULARY} from '../helpers/crmContactApi';

export const CONTACT_ORANGE = '#F97316';
export const TONE_COLORS = Object.freeze({positive: '#16A34A', neutral: '#F59E0B', negative: '#EF4444'});

export const CHANNEL_ICONS = Object.freeze({
    phone: 'phone-outline', email: 'email-outline', personal: 'handshake-outline', video: 'video-outline', sms: 'message-text-outline',
});

export const OUTCOME_ICONS = Object.freeze({
    interested: 'thumb-up-outline', callback: 'phone-return-outline', 'write-later': 'email-fast-outline', 'no-answer': 'phone-missed-outline',
    'left-message': 'voicemail', 'send-info': 'information-outline', 'meeting-booked': 'calendar-check-outline',
    'quote-requested': 'file-document-outline', 'not-now': 'clock-outline', 'not-interested': 'thumb-down-outline',
    'wrong-contact': 'account-cancel-outline',
});

export const FOLLOW_UP_ICONS = Object.freeze({
    call: 'phone-outline', email: 'email-outline', 'send-quote': 'file-document-edit-outline', meeting: 'calendar-account-outline',
    sms: 'message-text-outline', linkedin: 'linkedin', other: 'dots-horizontal',
});

/**
 * Tone bucket of an outcome.
 * @param {string} outcome outcome key.
 * @param {object} [vocab] server vocabulary.
 * @returns {'positive'|'neutral'|'negative'} tone.
 */
export const outcomeTone = (outcome, vocab) => {
    const nonConnect = vocab?.nonConnectOutcomes || FALLBACK_VOCABULARY.nonConnectOutcomes;
    const positive = vocab?.positiveOutcomes || FALLBACK_VOCABULARY.positiveOutcomes;

    if (outcome === 'not-interested' || nonConnect.includes(outcome)) {
        return 'negative';
    }

    return positive.includes(outcome) ? 'positive' : 'neutral';
};

/** Human label helpers (i18n; Hungarian default values live in the locale bundle). */
export const channelLabel = (t, key) => t(`sales.contact.channel_${key}`, {defaultValue: key});
export const outcomeLabel = (t, key) => t(`sales.contact.outcome_${key}`, {defaultValue: key});
export const followUpTypeLabel = (t, key) => t(`sales.contact.type_${key}`, {defaultValue: key});
